import { RootState } from '@app/redux/root-reducer';

export const selectMyTasksState = (store: RootState) => store.myTasksReducer.myTasks;
export const selectMyTaskDetailsState = (store: RootState) => store.myTasksReducer.myTaskDetails;
export const selectUpdateTaskStatusState = (store: RootState) =>
  store.myTasksReducer.updateTaskStatus;
